import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function FilterWidgetError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot fetch filters'}
    </Alert>
  );
}

export { FilterWidgetError };
